import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUserAiFeatureSettings as GetUserAiFeatureSettingsQuery,
    GetUserAiFeatureSettingsVariables as GetUserAiFeatureSettingsQueryVariables,
} from 'nutshell-graphql-types';

import GET_USER_AI_FEATURE_SETTINGS from '../queries/get-user-ai-feature-settings.graphql';

export const useGetUserAiFeatureSettings = (
    userId: string
): {
    isLoading: boolean;
    settings: GetUserAiFeatureSettingsQuery['user'] | null;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetUserAiFeatureSettingsQuery,
        GetUserAiFeatureSettingsQueryVariables
    >(GET_USER_AI_FEATURE_SETTINGS, {
        variables: {
            userId,
        },
        fetchPolicy: 'network-only',
    });

    const user = data ? data.user : null;

    return {
        isLoading: loading,
        settings: user,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
